module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_0.f87aeb86.png";